import React, { createContext, ReactNode } from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

import { createTheme, ThemeMode } from '../theme';

import { useThemeMode } from './ThemeModeProvider';

export const ThemeContext = createContext({
  themeMode: 'light',
} as {
  themeMode: ThemeMode;
  toggleThemeMode: VoidFunction;
});

interface ThemeProviderProps {
  primaryColor?: string;
  children: ReactNode;
}

export const ThemeProvider = ({ children, primaryColor }: ThemeProviderProps) => {
  const { themeMode } = useThemeMode();

  const theme = createTheme({ mode: themeMode, primaryColor });

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};
